export default __webpack_public_path__ + "static/media/photo--sm--kara3.d9097e62.jpg";